// extracted by mini-css-extract-plugin
export default {"map-frame":"MapFrame_map-frame__1W6d_","map-frame--customise":"MapFrame_map-frame--customise__1hqzu"};